/**
 * 将 Title Case 格式转换为驼峰格式
 * @param str Title Case 格式字符串
 * @returns 驼峰格式字符串
 */
export const titleCaseToCamelCase = (str: string) => {
  return str.charAt(0).toLowerCase() + str.slice(1).replace(/\s+(\w)/g, (_, p1) => p1.toUpperCase());
};
